import React from 'react';
import Notification from '@anwb/notification';
export const ValidationNotification = () => {
    return React.createElement(Notification, { variant: "error", title: "Niet alle velden zijn correct ingevuld" });
};
//# sourceMappingURL=ValidationNotification.js.map